import React from 'react';

import { GroupProps, Text, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

interface ICardInfoLineProps extends GroupProps {
  label: string;
  description: string | JSX.Element;
}

const CardInfoLine = ({ label, description }: ICardInfoLineProps): JSX.Element => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.sm}`, false);
  return (
    <>
      <Text fs='italic' c='dimmed' fz='xs' ta='right'>
        {label}
      </Text>
      <Text
        fz='sm'
        ta='left'
        data-cy={`${label}GeneralInfo`}
        sx={{ whiteSpace: isDesktop ? 'nowrap' : 'break-spaces' }}
      >
        {description}
      </Text>
    </>
  );
};

export default CardInfoLine;
